<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID｛zb_user.id｝" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID｛zb_user.id｝" />
      </a-form-model-item>
      <a-form-model-item label="类型 1-满减券 2-立减券 3-拉新优惠券 4-免邮券 5-品类券" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="状态 1-待使用 2-已使用 3-已过期" prop="status" >
      </a-form-model-item>
      <a-form-model-item label="优惠券ID" prop="couponId" >
        <a-input v-model="form.couponId" placeholder="请输入优惠券ID" />
      </a-form-model-item>
      <a-form-model-item label="优惠券名称" prop="couponName" >
        <a-input v-model="form.couponName" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="使用有效期" prop="validPeriod" >
      </a-form-model-item>
      <a-form-model-item label="满减标准金额" prop="fullMoney" >
        <a-input v-model="form.fullMoney" placeholder="请输入满减标准金额" />
      </a-form-model-item>
      <a-form-model-item label="优惠金额" prop="discountMoney" >
        <a-input v-model="form.discountMoney" placeholder="请输入优惠金额" />
      </a-form-model-item>
      <a-form-model-item label="商品分类ids" prop="categoryIds" >
        <a-input v-model="form.categoryIds" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCoupon, addCoupon, updateCoupon } from '@/api/user/coupon'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        type: null,

        status: 0,

        couponId: null,

        couponName: null,

        validPeriod: null,

        fullMoney: null,

        discountMoney: null,

        categoryIds: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户ID｛zb_user.id｝不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型 1-满减券 2-立减券 3-拉新优惠券 4-免邮券 5-品类券不能为空', trigger: 'change' }
        ],
        status: [
          { required: true, message: '状态 1-待使用 2-已使用 3-已过期不能为空', trigger: 'blur' }
        ],
        couponId: [
          { required: true, message: '优惠券ID不能为空', trigger: 'blur' }
        ],
        couponName: [
          { required: true, message: '优惠券名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        status: 0,
        couponId: null,
        couponName: null,
        validPeriod: null,
        fullMoney: null,
        discountMoney: null,
        categoryIds: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCoupon({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCoupon(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCoupon(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
